import BusinessDetail from './BusinessDetail';

export default BusinessDetail;



// WEBPACK FOOTER //
// ./src/scenes/Business/BusinessDetail/index.ts